import React, { useState, useEffect, useContext, useMemo, useRef } from "react";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import axios from "axios";
import "./../style.css";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { color } from "d3-color";
import { interpolateRgb } from "d3-interpolate";
import { useSelector } from "react-redux";
import LinkIcon from '@mui/icons-material/Link';
import { useNavigate, Link } from 'react-router-dom';
import { useDispatch } from "react-redux";
import { SetredirectValue } from "../../../Store/PageredirectSlice";
import { Helmet } from 'react-helmet';
import { ToastContainer, toast } from 'react-toastify';
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import Rightsidebar from "../Rightsidebar/Rightsidebar";
import { Commonfun } from './../Commonfun';
import { AppContext } from "../../../Context/Context";
import { timezoneval } from './../Commonfun';
import { timezonechange } from "./../Commonfun";
import { Utils } from "../../../Utils/Utils";
import Freeaudit from "../../../Utils/Freeaudit";
import Loader from "../CommonLoader";
import CommonAlert from "../../../Commonalert/commonalert";
import DatagridComp from "../DatagridComp";
import PdfandCsv from "../PdfandCsv";
import CommonBreadCrumb from "../../../Commonalert/commonbreadcrumb";
import { Container, Grid, Typography } from '@mui/material';
import UserActivityTracker from "../../../hooks/userActivityTracker";
import Chart from "react-apexcharts";

export default function TopactionItems() {

  const { isMenuExpanded, setIsMenuExpanded } = useContext(AppContext);
  const [cardData, setCardData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [jobDate, setjobDate] = useState("");
  const [notifycount, setNotifycount] = useState("");
  const [topActionItemPlan, settopActionItemPlan] = useState({ status: true, error: "" });
  const [isDownloading, setIsDownloading] = useState(false);
  const [isDownloadingcsv, setIsDownloadingcsv] = useState(false);

  const esodata = useSelector((state) => state);
  const ApiToken = esodata.apiauthkey.value
  const [autoheightval, SetAutoheightval] = useState(true)
  const [faqData, setfaqData] = useState("2")
  const [toggle, setToggle] = useState(false);
  const [initialfaqDateval, SetInitialfaqDateval] = useState([]);
  const [apiopen, setapiOpen] = React.useState(false);
  const [apierrorMsg, setapierrorMsg] = useState();
  const [openCommonAlerts, setOpenCommonAlerts] = useState(false);
  const [tableLoading, setTableLoading] = useState(true);
  const [summaryData, setSummaryData] = useState({
    "severity_distribution": {
      "High": 0,
      "Medium": 0,
      "Low": 0
    },
    "category_wise_issues": {
      "Accessibility": 0,
      "Content": 0,
      "Meta data": 0
    },
    "issue_contribution": [],
    "top_5_critical": []
  });

  const navigate = useNavigate()
  var startColor = "#6495ed";
  var endColor = "#dc143c";
  const interpolate = interpolateRgb(startColor, endColor);
  const fillColor = "rgb(255,174,31)";
  const textfillColor = "rgb(255,255,255)";
  const dispatch = useDispatch();

  const gradientStops = [
    {
      key: "0%",
      stopColor: color(fillColor).darker(0.5).toString(),
      stopOpacity: 1,
      offset: "0%",
    },
    {
      key: "50%",
      stopColor: fillColor,
      stopOpacity: 0.75,
      offset: "50%",
    },
    {
      key: "100%",
      stopColor: color(fillColor).brighter(0.5).toString(),
      stopOpacity: 0.5,
      offset: "100%",
    },
  ];
  const apihandleClose = () => {
    setapiOpen(false);
  };
  const pageRedirectfun = (e) => {
    if (e.currentTarget.id == 1)
      countdecreaseUrl("Broken Links")
    else
      countdecreaseUrl("Server Error")
    localStorage.setItem("eso_redirect_value", e.currentTarget.id);
    dispatch(SetredirectValue(e.currentTarget.id));
    navigate('/internal-link-checker')
  }
  const countdecreaseUrl = async (urldecval) => {
    const notifydecdatavalue = await axios.get(
      `${process.env.REACT_APP_API_URL}top_action_items/reduce_notification/?user_domain_id=${esodata.domaindata.value.header_selected}&to_redirect=${urldecval}`, {
      headers: {
        Authorization: `${ApiToken}`,
      },
    }
    ).catch((error) => {
      if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
        setapiOpen(true);
        setapierrorMsg(error?.response?.data?.error)
      }
      else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
        navigate('/errorpages')
      }
    });
    notificationapi();

  }
  const redirectFun = (e) => {
    if (e.currentTarget.id == "google_analytics") {
      countdecreaseUrl('High Bounce Rate')
      navigate('/organic-search-traffic')
    }
    else if (e.currentTarget.id == "Performance") {
      countdecreaseUrl(e.target.getAttribute('dataid'))
      navigate('/performance')
    }
    else if (e.currentTarget.id == "Content") {
      navigate('/analysis-summary')
    }
    else if (e.currentTarget.id == "missing_title") {
      countdecreaseUrl('Missing Titles')
      navigate('/onpage-crawl-data/2/2')
    }
    else if (e.currentTarget.id == "duplicate_tItles") {
      countdecreaseUrl('Duplicate Titles')
      navigate('/onpage-crawl-data/2/4')
    }
    else if (e.currentTarget.id == "missing_canonical_url") {
      countdecreaseUrl('Missing Canonical URLs')
      navigate('/onpage-crawl-data/2/14')
    }
    else if (e.currentTarget.id == "missing_alt_tags") {
      countdecreaseUrl('Missing ALT Tags')
      navigate('/onpage-crawl-data/2/18')
    }
    else if (e.currentTarget.id == "duplicate_descriptions") {
      countdecreaseUrl('Duplicate Descriptions')
      navigate('/onpage-crawl-data/2/5')
    }
    else if (e.currentTarget.id == "Hreflang") {
      countdecreaseUrl('Hreflang')
      navigate('/onpage-crawl-data/2/9')
    }
    else if (e.currentTarget.id == "Keyword") {
      navigate('/google-console/search-queries')
    }
    else if (e.currentTarget.id == "Pages") {
      navigate('/google-console/top-performing-pages')
    }
    else if (e.currentTarget.id == "Missing_H1_Tags") {
      countdecreaseUrl("Missing H1 Tags")
      navigate('/onpage-crawl-data/2/16')
    }
    else if (e.currentTarget.id == "Missing_Descriptions") {
      countdecreaseUrl("Missing Descriptions")
      navigate('/onpage-crawl-data/2/15')
    }
    else if (e.currentTarget.id == "Duplicate_H1_Tags") {
      countdecreaseUrl('Duplicate H1 Tags')
      navigate('/onpage-crawl-data/2/7')
    }
    else if (e.currentTarget.id == "Accessibility_Score") {
      countdecreaseUrl("Accessibility Score")
      navigate('/accessibility-score')
    }
    else if (e.currentTarget.id == "Accessibility_Report") {
      countdecreaseUrl("Accessibility Report")
      navigate('/accessibility-report')
    }
    else if (e.currentTarget.id == "Misspelled_Sentence") {
      countdecreaseUrl("Suggested Sentences")
      navigate('/spell-checker')
    }
    else if (e.currentTarget.id == "Missed_Opportunities") {
      countdecreaseUrl()
      navigate('/missed-opportunity')
    }
    else if (e.currentTarget.id == "Keyword_need_optimization") {
      countdecreaseUrl('Keywords that need optimization')
      navigate('/google-console/search-queries')
    }
    else if (e.currentTarget.id == "Multiple_H1_Tags") {
      countdecreaseUrl('Multiple H1 Tags')
      navigate('/onpage-crawl-data/2/19')
    }


  }
  const StyledGridOverlay = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    "& .ant-empty-img-1": {
      fill: theme.palette.mode === "light" ? "#aeb8c2" : "#262626",
    },
    "& .ant-empty-img-2": {
      fill: theme.palette.mode === "light" ? "#f5f5f7" : "#595959",
    },
    "& .ant-empty-img-3": {
      fill: theme.palette.mode === "light" ? "#dce0e6" : "#434343",
    },
    "& .ant-empty-img-4": {
      fill: theme.palette.mode === "light" ? "#fff" : "#1c1c1c",
    },
    "& .ant-empty-img-5": {
      fillOpacity: theme.palette.mode === "light" ? "0.8" : "0.08",
      fill: theme.palette.mode === "light" ? "#f5f5f5" : "#fff",
    },
  }));


  const MyCustomNoRowsOverlay = () => (
    <StyledGridOverlay>
      <svg
        width="120"
        height="100"
        viewBox="0 0 184 152"
        aria-hidden
        focusable="false"
      >
        <g fill="none" fillRule="evenodd">
          <g transform="translate(24 31.67)">
            <ellipse
              className="ant-empty-img-5"
              cx="67.797"
              cy="106.89"
              rx="67.797"
              ry="12.668"
            />
            <path
              className="ant-empty-img-1"
              d="M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z"
            />
            <path
              className="ant-empty-img-2"
              d="M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"
            />
            <path
              className="ant-empty-img-3"
              d="M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z"
            />
          </g>
          <path
            className="ant-empty-img-3"
            d="M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z"
          />
          <g className="ant-empty-img-4" transform="translate(149.65 15.383)">
            <ellipse cx="20.654" cy="3.167" rx="2.849" ry="2.815" />
            <path d="M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z" />
          </g>
        </g>
      </svg>
      <Box sx={{ mt: 1 }}>No Data</Box>
    </StyledGridOverlay>
  );

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [validation, setValidation] = useState({
    dateerror: "",
  });
  let errors = { ...validation };
  let subtitle;
  let detailurl = `${process.env.REACT_APP_DOMAIN}source-code-detail/`;

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
    },
  };

  const checkUserPlan = async () => {
    const topActionItemP = await Utils("top_action_items", ApiToken);
    if (topActionItemP.status) {
      callUserdataApi();
      faqdatafun();
      notificationapi();
    }
    settopActionItemPlan(topActionItemP);
  };

  const arr = [];

  useEffect(() => {
    checkUserPlan();
  }, []);
  const columns = [
    // {
    //   field: "priority",
    //   headerName: "#",
    //   description: 'priority',
    //   minWidth: 100,
    //   flex: 1,
    //   headerAlign: 'center',
    //   align: 'center',
    //   sortable: true,
    // },

    {
      field: "category",
      headerName: "Category",
      description: 'The category of the issue being identified.',
      minWidth: 150,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: true,
      renderCell: (cardData) => {
        if (cardData.row.category && cardData.row.category === 'Keyword') {
          if (cardData.row.action_items == "Missed Opportunities") {
            return (
              <div>
                <span onClick={redirectFun} id="Missed_Opportunities">{cardData.row.category}</span>
              </div>
            )
          }
          else if (cardData.row.action_items == "Keywords that need optimization") {
            return (
              <div>
                <span onClick={redirectFun} id="duplicate_tItles">{cardData.row.category}</span>
              </div>
            )
          }

        }
        else if (cardData.row.category && cardData.row.category === 'Meta data') {
          if (cardData.row.action_items == "Missing Titles") {
            return (
              <div>
                <span onClick={redirectFun} id="missing_title">{cardData.row.category}</span>
              </div>
            )
          }
          else if (cardData.row.action_items == "Duplicate Titles") {
            return (
              <div>
                <span onClick={redirectFun} id="duplicate_tItles">{cardData.row.category}</span>
              </div>
            )
          }
          else if (cardData.row.action_items == "Missing Canonical URLs") {
            return (
              <div>
                <span onClick={redirectFun} id="missing_canonical_url">{cardData.row.category}</span>
              </div>
            )
          }
          else if (cardData.row.action_items == "Missing ALT Tags") {
            return (
              <div>
                <span onClick={redirectFun} id="missing_alt_tags">{cardData.row.category}</span>
              </div>
            )
          }
          else if (cardData.row.action_items == "Duplicate Descriptions") {
            return (
              <div>
                <span onClick={redirectFun} id="duplicate_descriptions">{cardData.row.category}</span>
              </div>
            )
          }
          else if (cardData.row.action_items == "Pages") {
            return (
              <div>
                <span onClick={redirectFun} id="Pages">{cardData.row.category}</span>
              </div>
            )
          }
          else if (cardData.row.action_items == "Hreflang") {
            return (
              <div>
                <span onClick={redirectFun} id="Hreflang">{cardData.row.category}</span>
              </div>
            )
          }
          else if (cardData.row.action_items == "Missing H1 Tags") {
            return (
              <div>
                <span onClick={redirectFun} id="Missing_H1_Tags">{cardData.row.category}</span>
              </div>
            )
          }
          else if (cardData.row.action_items == "Missing Descriptions") {
            return (
              <div>
                <span onClick={redirectFun} id="Missing_Descriptions">{cardData.row.category}</span>
              </div>
            )
          }
          else if (cardData.row.action_items == "Duplicate H1 Tags") {
            return (
              <div>
                <span onClick={redirectFun} id="Duplicate_H1_Tags">{cardData.row.category}</span>
              </div>
            )
          }
          else if (cardData.row.action_items == "Multiple H1 Tags") {
            return (
              <div>
                <span onClick={redirectFun} id="Multiple_H1_Tags">{cardData.row.category}</span>
              </div>
            )
          }
        }
        else if (cardData.row.category && cardData.row.category === 'Domain Performance') {
          return (
            <div>
              <span onClick={redirectFun} id="Performance" dataid={cardData.row.action_items}>{cardData.row.category}</span>
            </div>
          )
        }
        else if (cardData.row.category && cardData.row.category === 'Pages') {
          return (
            <div>
              <span onClick={redirectFun} id="Pages">{cardData.row.category}</span>
            </div>
          )
        }
        else if (cardData.row.category && cardData.row.category === 'Links') {
          if (cardData.row.action_items == "Server Error") {
            return (
              <div>
                <span onClick={pageRedirectfun} id="2">{cardData.row.category}</span>
              </div>
            )
          }
          else if (cardData.row.action_items == "Broken Links") {
            return (
              <div>
                <span onClick={pageRedirectfun} id="1">{cardData.row.category}</span>
              </div>
            )
          }

        }
        else if (cardData.row.category && cardData.row.category === 'Visitor') {
          return (
            <div>
              <span onClick={redirectFun} id="google_analytics">{cardData.row.category}</span>
            </div>
          )
        }
        else if (cardData.row.category && cardData.row.category === 'Performance') {
          return (
            <div>
              <span onClick={redirectFun} id="Performance" dataid={cardData.row.action_items}>{cardData.row.category}</span>
            </div>
          )
        }
        else if (cardData.row.category && cardData.row.category === 'Content') {
          if (cardData.row.action_items == "Suggested Sentences") {
            return (
              <div>
                <span onClick={redirectFun} id="Misspelled_Sentence">{cardData.row.category}</span>
              </div>
            )
          }
          else if (cardData.row.action_items == "Sentences with Suggestions") {
            return (
              <div>
                <span onClick={redirectFun} id="Misspelled_Sentence">{cardData.row.category}</span>
              </div>
            )
          }
          else if (cardData.row.action_items == "Missing Descriptions") {
            return (
              <div>
                <span onClick={redirectFun} id="Misspelled_Descriptions">{cardData.row.category}</span>
              </div>
            )
          }
          else {
            return (
              <div>
                <span onClick={redirectFun} id="Content">{cardData.row.category}</span>
              </div>
            )
          }

        }
        else if (cardData.row.category && cardData.row.category === 'Accessibility') {
          if (cardData.row.action_items == "Accessibility Score") {
            return (
              <div>
                <span onClick={redirectFun} id="Accessibility_Score">{cardData.row.category}</span>
              </div>
            )
          }
          if (cardData.row.action_items == "Accessibility Report") {
            return (
              <div>
                <span onClick={redirectFun} id="Accessibility_Report">{cardData.row.category}</span>
              </div>
            )
          }
        }

      },
    },
    {
      field: "action_items",
      headerName: "Action Items",
      description: 'The specific tasks or issues identified that need attention or improvement.',
      minWidth: 320,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: true,
      renderCell: (cardData) => {
        if (cardData.row.category && cardData.row.category === 'Keyword') {
          if (cardData.row.action_items == "Keywords that need optimization") {
            return (

              <div className="table-link-url" onClick={redirectFun} id="Keyword_need_optimization">
                <LinkIcon style={{ fill: "#044792" }} />
                <span className="spanlink"> {cardData.row.action_items}</span>
              </div>
            )
          }
          if (cardData.row.action_items == "Missed Opportunities") {
            return (
              <div className="table-link-url" onClick={redirectFun} id="Missed_Opportunities">
                <LinkIcon style={{ fill: "#044792" }} />
                <span className="spanlink">{cardData.row.action_items}</span>
              </div>
            )
          }

        }
        else if (cardData.row.category && cardData.row.category === 'Meta data') {
          if (cardData.row.action_items == "Missing Titles") {
            return (
              <div className="table-link-url" onClick={redirectFun} id="missing_title">
                <LinkIcon style={{ fill: "#044792" }} />
                <span className="spanlink">{cardData.row.action_items}</span>
              </div>
            )
          }
          else if (cardData.row.action_items == "Duplicate Titles") {
            return (
              <div className="table-link-url" onClick={redirectFun} id="duplicate_tItles">
                <LinkIcon style={{ fill: "#044792" }} />
                <span className="spanlink"> {cardData.row.action_items}</span>
              </div>
            )
          }
          else if (cardData.row.action_items == "Missing Canonical URLs") {
            return (
              <div className="table-link-url" onClick={redirectFun} id="missing_canonical_url">
                <LinkIcon style={{ fill: "#044792" }} />
                <span className="spanlink">  {cardData.row.action_items}</span>
              </div>
            )
          }
          else if (cardData.row.action_items == "Missing ALT Tags") {
            return (
              <div className="table-link-url" onClick={redirectFun} id="missing_alt_tags">
                <LinkIcon style={{ fill: "#044792" }} />
                <span className="spanlink"> {cardData.row.action_items}</span>
              </div>
            )
          }
          else if (cardData.row.action_items == "Duplicate Descriptions") {
            return (
              <div className="table-link-url" onClick={redirectFun} id="duplicate_descriptions">
                <LinkIcon style={{ fill: "#044792" }} />
                <span className="spanlink">{cardData.row.action_items}</span>
              </div>
            )
          }
          else if (cardData.row.category && cardData.row.action_items === 'Hreflang') {
            return (
              <div className="table-link-url" onClick={redirectFun} id="Hreflang">
                <LinkIcon style={{ fill: "#044792" }} />
                <span className="spanlink">  {cardData.row.action_items}</span>
              </div>
            )
          }
          else if (cardData.row.category && cardData.row.action_items === 'Missing H1 Tags') {
            return (
              <div className="table-link-url" onClick={redirectFun} id="Missing_H1_Tags">
                <LinkIcon style={{ fill: "#044792" }} />
                <span className="spanlink">  {cardData.row.action_items}</span>
              </div>
            )
          }
          else if (cardData.row.category && cardData.row.action_items === 'Missing Descriptions') {
            return (
              <div className="table-link-url" onClick={redirectFun} id="Missing_Descriptions">
                <LinkIcon style={{ fill: "#044792" }} />
                <span className="spanlink"> {cardData.row.action_items}</span>
              </div>
            )
          }
          else if (cardData.row.category && cardData.row.action_items === 'Duplicate H1 Tags') {
            return (
              <div className="table-link-url" onClick={redirectFun} id="Duplicate_H1_Tags">
                <LinkIcon style={{ fill: "#044792" }} />
                <span className="spanlink"> {cardData.row.action_items}</span>
              </div>
            )
          }
          else if (cardData.row.category && cardData.row.action_items === 'Multiple H1 Tags') {
            return (
              <div className="table-link-url" onClick={redirectFun} id="Multiple_H1_Tags">
                <LinkIcon style={{ fill: "#044792" }} />
                <span className="spanlink">  {cardData.row.action_items}</span>
              </div>
            )
          }
        }
        else if (cardData.row.category && cardData.row.category === 'Domain Performance') {
          return (
            <div className="table-link-url" onClick={redirectFun} id="Performance" dataid={cardData.row.action_items}>
              <LinkIcon style={{ fill: "#044792" }} />
              <span className="spanlink">  {cardData.row.action_items}</span>
            </div>
          )
        }
        else if (cardData.row.category && cardData.row.category === 'Pages') {
          return (
            <div className="table-link-url" onClick={redirectFun} id="Pages">
              <LinkIcon style={{ fill: "#044792" }} />
              <span className="spanlink">  {cardData.row.action_items}</span>
            </div>
          )
        }
        else if (cardData.row.category && cardData.row.category === 'Links') {
          if (cardData.row.action_items == "Server Error") {
            return (
              <div className="table-link-url" onClick={pageRedirectfun} id="2">
                <LinkIcon style={{ fill: "#044792" }} />
                <span className="spanlink"> {cardData.row.action_items}</span>
              </div>
            )
          }
          else if (cardData.row.action_items == "Broken Links") {
            return (
              <div className="table-link-url" onClick={pageRedirectfun} id="1">
                <LinkIcon style={{ fill: "#044792" }} />
                <span className="spanlink">  {cardData.row.action_items}</span>
              </div>
            )
          }

        }
        else if (cardData.row.category && cardData.row.category === 'Visitor') {
          return (
            <div className="table-link-url" onClick={redirectFun} id="google_analytics">
              <LinkIcon style={{ fill: "#044792" }} />
              <span className="spanlink">   {cardData.row.action_items}</span>
            </div>
          )
        }
        else if (cardData.row.category && cardData.row.category === 'Performance') {
          return (
            <div className="table-link-url" onClick={redirectFun} id="Performance" dataid={cardData.row.action_items}>
              <LinkIcon style={{ fill: "#044792" }} />
              <span className="spanlink">   {cardData.row.action_items}</span>
            </div>
          )
        }
        else if (cardData.row.category && cardData.row.category === 'Content') {
          if (cardData.row.action_items == "Sentences with Suggestions") {
            return (
              <div className="table-link-url" onClick={redirectFun} id="Misspelled_Sentence">
                <LinkIcon style={{ fill: "#044792" }} />
                <span className="spanlink">{cardData.row.action_items}</span>
              </div>
            )
          }
          else {
            return (
              <div className="table-link-url" onClick={redirectFun} id="Content">
                <LinkIcon style={{ fill: "#044792" }} />
                <span className="spanlink">{cardData.row.action_items}</span>
              </div>
            )
          }

        }
        else if (cardData.row.category && cardData.row.category === 'Accessibility') {
          if (cardData.row.action_items == "Accessibility Score") {
            return (
              <div className="table-link-url" onClick={redirectFun} id="Accessibility_Score">
                <LinkIcon style={{ fill: "#044792" }} />
                <span className="spanlink">  {cardData.row.action_items}</span>
              </div>
            )
          }
          if (cardData.row.action_items == "Accessibility Report") {
            return (
              <div className="table-link-url" onClick={redirectFun} id="Accessibility_Report">
                <LinkIcon style={{ fill: "#044792" }} />
                <span className="spanlink">  {cardData.row.action_items}</span>
              </div>
            )
          }
        }

      },
    },
    {
      field: "severity",
      headerName: "Severity",
      description: 'Indicates how critical the issue is. A higher severity suggests the issue is more urgent and requires immediate action.',
      minWidth: 150,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: true,
    },
    {
      field: "impact",
      headerName: "Impact",
      description: 'The number of occurrences of the issue. A higher impact means the problem is more widespread.',
      minWidth: 150,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: true,
    },
    {
      field: "percentage_to_total",
      headerName: "% Total",
      description: 'The percentage that this issue represents in relation to the total number of issues assessed. It shows the relative weight of the problem.',
      minWidth: 150,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: true,
      renderCell: (cardData) => {
        return cardData.row.percentage_to_total + "%";
      }
    },

  ];

  const rows = cardData ?? [];
  const notificationapi = async () => {
    const notifydatavalue = await axios.get(
      `${process.env.REACT_APP_API_URL}top_action_items/top_action_notification/?user_domain_id=${esodata.domaindata.value.header_selected}`, {
      headers: {
        Authorization: `${ApiToken}`,
      },
    }
    ).catch((error) => {
      if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
        setapiOpen(true);
        setapierrorMsg(error?.response?.data?.error)
      }
      else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
        navigate('/errorpages')
      }
    });
    setNotifycount(notifydatavalue?.data?.notification_count)
  }
  const callUserdataApi = async (jobid = "") => {
    setLoading(true);
    setTableLoading(true);

    const datavalue = await axios.get(
      `${process.env.REACT_APP_API_URL}top_action_items/top_action_table_view/?user_domain_id=${esodata.domaindata.value.header_selected}`, {
      headers: {
        Authorization: `${ApiToken}`,
      },
    }
    ).catch((error) => {
      if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
        setapiOpen(true);
        setapierrorMsg(error?.response?.data?.error)
      }
      else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
        navigate('/errorpages')
      }
    });
    if (datavalue?.data.top_actions && datavalue?.data?.top_actions.length > 0) {
      const dataval = datavalue?.data?.top_actions;
      setjobDate(moment(datavalue?.data?.job_date).format("MMMM DD,YYYY HH:mm"));
      SetAutoheightval(false)

      const newData = dataval.map((obj, index) => {
        return { ...obj, sid: index + 1 };
      });
      setCardData(newData);
    }
    else {
      SetAutoheightval(true)
      setCardData("");
    }

    if (datavalue?.data) {
      setSummaryData({
        "severity_distribution": {
          "High": datavalue?.data?.summary?.severity_distribution?.High || 0,
          "Medium": datavalue?.data?.summary?.severity_distribution?.Medium || 0,
          "Low": datavalue?.data?.summary?.severity_distribution?.Low || 0
        },
        "category_wise_issues": {
          "Accessibility": datavalue?.data?.summary?.category_wise_issues?.Accessibility || 0,
          "Content": datavalue?.data?.summary?.category_wise_issues?.Content || 0,
          "Meta data": datavalue?.data?.summary?.category_wise_issues["Meta data"] || 0
        },
        "issue_contribution": datavalue?.data?.summary?.issue_contribution || [],
        "top_5_critical": datavalue?.data?.summary?.top_5_critical || []
      })
    }

    setTableLoading(false);
    setLoading(false);
  };
  const pdfdown = async () => {

    setLoading(true);
    setIsDownloading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}top_action_items/top_action_table_view/?user_domain_id=${esodata.domaindata.value.header_selected}&is_format=pdf&timezone=${timezoneval()}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/pdf',
          Authorization: `${ApiToken}`,
        },
      });

      if (response.ok) {

        const blob = await response.blob();


        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        var filedata = await Commonfun("Topaction", "pdf", ApiToken, esodata.domaindata.value.header_selected);
        link.download = filedata;
        link.click();


        window.URL.revokeObjectURL(link.href);
      } else {
        if (response?.status == 599 || response?.status == 500 || response?.status == 400 || response?.status == 404) {
          response.json().then(data => {
            setapiOpen(true);
            setapierrorMsg(data?.error)
          })
        }
        else if (response?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      }
    } catch (error) {
      toast.error("No Data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      console.error('Error during PDF download:', error);
    }
    setLoading(false);
    setIsDownloading(false);


  }
  const csvdown = async () => {
    setLoading(true);
    setIsDownloadingcsv(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}top_action_items/top_action_table_view/?user_domain_id=${esodata.domaindata.value.header_selected}&is_format=csv&timezone=${timezoneval()}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/pdf',
          Authorization: `${ApiToken}`,
        },
      });
      if (response.ok) {
        const blob = await response.blob();
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'topactionItem.csv';

        link.click();


        window.URL.revokeObjectURL(link.href);
      } else {
        if (response?.status == 599 || response?.status == 500 || response?.status == 400 || response?.status == 404) {
          response.json().then(data => {
            setapiOpen(true);
            setapierrorMsg(data?.error)
          })
        }
        else if (response?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      }
    } catch (error) {
      toast.error("No Data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      console.error('Error during PDF download:', error);
    }
    setLoading(false);
    setIsDownloadingcsv(false);

  }

  const faqdatafun = async (menubutval = "") => {
    var datavar = `${process.env.REACT_APP_API_URL}domain/frequently_asked_questions/?menu=41`

    try {
      const doaminsectiondatavalue = await axios.get(
        datavar,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });
      if (doaminsectiondatavalue?.data) {
        SetInitialfaqDateval(doaminsectiondatavalue?.data?.faqs)
      }
    } catch (err) { }
  }
  const handleToggle = () => {
    if (faqData != 1) {
      setfaqData(1)
    }
    else {
      setfaqData(2)
    }
    setToggle((pre) => !pre);
  };
  const getRowClassName = (params) => {
    if (params.row.notification === true) {
      return 'row-odd-con';
    }

  };

  const [download, setDownload] = useState(false);
  const dropdownRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDownload(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleDownlodingCSV = () => {
    csvdown();
  }

  const handleDownlodingPDF = () => {
    pdfdown();
  }


  return (
    <div className={`over_all_container top_action_list ${isMenuExpanded ? "blur overflow-hidden" : ""}`}>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Helmet>
        <meta charSet="utf-8" />
        <title>Top Action Items</title>
      </Helmet>

      {loading === true ? <Loader /> : null}

      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={4}>
              <div>
                <h1 className="dashboard_header">
                  Top Action Items
                  <span className="faq-chip" onClick={handleToggle}>FAQ's</span>
                </h1>
              </div>
            </Grid>
            <Grid item xs={12} md={8}>
              <div className="top_breadcrumb_menu">
                <div className="exportpdf_outer">
                  <div className="breadcrumb-wrapper">
                    <CommonBreadCrumb breadcrumbValue={[
                      { title: 'Top Action Items', activeColor: true }
                    ]} />
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>






      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box-time">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={6}>
              <div className="time_zone">

                <span className="timezone-date">{timezonechange(jobDate)} </span><br />
                <span className="timezone-val">{timezoneval()}</span>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>

            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="dashboard-container">
        <Grid container spacing={2} style={{ marginBottom: '20px' }}>

          <Grid item xs={12} md={3.5}>
            <Box className="grid_table_shodow" style={{ padding: '15px', height: '300px' }}>
              <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '10px' }}>Issues by Category</Typography>
              <Chart
                type="donut"
                height={240}
                series={Object.values(summaryData.category_wise_issues)}
                options={{
                  labels: Object.keys(summaryData.category_wise_issues),
                  legend: { position: 'bottom', fontSize: '10px' },
                  dataLabels: { enabled: false }
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={3.5}>
            <Box className="grid_table_shodow" style={{ padding: '15px', height: '300px' }}>
              <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '10px' }}>Issues by Severity</Typography>
              <Chart
                type="donut"
                height={240}
                series={Object.values(summaryData.severity_distribution) || []}
                options={{
                  labels: Object.keys(summaryData.severity_distribution) || [],
                  legend: { position: 'bottom', fontSize: '10px' },
                  dataLabels: { enabled: false }
                }}
              />
            </Box>
          </Grid>


          {/* <Grid item xs={12} md={6}>
            <Box className="grid_table_shodow" style={{ padding: '15px', height: '300px' }}>
              <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '10px' }}>AI Interaction Metrics</Typography>
              <Chart
                type="bar"
                height={240}
                series={[{
                  name: "Count",
                  data: (summaryData.issue_contribution || []).map(i => i?.value || 0)
                }]}
                options={{
                  chart: { toolbar: { show: false } },
                  plotOptions: {
                    bar: {
                      horizontal: false,
                      columnWidth: '45%',
                      borderRadius: 4,
                      distributed: true, // 👈 IMPORTANT
                      dataLabels: { position: 'top' }
                    }
                  },
                  colors: ["#3f51b5", "#d97757", "#00C9A7", "#FF4D4F", '#ae36ee', '#c9d429'], // 👈 each bar gets color
                  dataLabels: {
                    enabled: true,
                    offsetY: -20,
                    style: { fontSize: '12px' }
                  },
                  xaxis: {
                    categories: (summaryData.issue_contribution || []).map(i => i?.label.slice(0, 10) + "..." || ""),
                    position: 'bottom',
                    labels: {
                      offsetX: 50,
                      style: { fontSize: '11px' }
                    }
                  },
                  yaxis: {
                    title: { text: 'Count' },
                    labels: { formatter: (val) => Math.floor(val) }
                  },
                  noData: { text: "No Metric Data Available" }
                }}
              />
            </Box>
          </Grid> */}

          {/* <Grid item xs={12} md={6}>
            <Box className="grid_table_shodow" style={{ padding: '15px', height: '300px' }}>
              <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '10px' }}>AI Interaction Metrics</Typography>
              <Chart
                type="bar"
                height={240}
                series={[{
                  name: "Count",
                  data: (summaryData.top_5_critical || []).map(i => i?.percentage_to_total || 0)
                }]}
                options={{
                  chart: { toolbar: { show: false } },
                  plotOptions: {
                    bar: {
                      horizontal: false,
                      columnWidth: '45%',
                      borderRadius: 4,
                      distributed: true, // 👈 IMPORTANT
                      dataLabels: { position: 'top' },
                    }
                  },
                  colors: ["#3f51b5", "#d97757", "#00C9A7", "#FF4D4F", '#ae36ee', '#c9d429'], // 👈 each bar gets color
                  dataLabels: {
                    enabled: true,
                    offsetY: -20,
                    style: { fontSize: '12px' }
                  },
                  xaxis: {
                    categories: (summaryData.top_5_critical || []).map(i => i?.action_items.slice(0, 10) + "..." || ""),
                    position: 'bottom',
                    labels: {
                      offsetX: 50,
                      style: { fontSize: '11px' }
                    }
                  },
                  yaxis: {
                    title: { text: 'Count' },
                    labels: { formatter: (val) => Math.floor(val) }
                  },
                  noData: { text: "No Metric Data Available" }
                }}
              />
            </Box>
          </Grid> */}

          <Grid item xs={12} md={5}>
            <Box className="grid_table_shodow" style={{ padding: '15px', height: '300px' }}>
              <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '10px' }}>High Impact Issues</Typography>
              <Chart
                type="bar"
                height={200}
                series={[{ name: "Percentage", data: summaryData?.top_5_critical.map(i => i.percentage_to_total) }]}
                options={{
                  chart: { toolbar: { show: false } },
                  plotOptions: { bar: { horizontal: true, barHeight: '30%', borderRadius: 4 } },
                  colors: ["#2e7d32"],
                  xaxis: { categories: summaryData?.top_5_critical.map(i => i.action_items), labels: { show: false } },
                  dataLabels: { enabled: true, formatter: (val) => `${val}%`, position: 'right' },
                  tooltip: {
                    custom: ({ dataPointIndex }) => {
                      const item = summaryData?.top_5_critical[dataPointIndex];
                      return `
          <div style="padding:8px 10px;">
            <strong>${item.action_items}</strong><br/>
            Impact: ${item.impact}<br/>
            Percentage: ${item.percentage_to_total}%
          </div>
        `;
                    },
                  },
                }}
              />
            </Box>
          </Grid>

        </Grid>
      </Container>


      <Container maxWidth={false} className="dashboard-container">
        <Box className="grid_table_shodow">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={12}>
              <div className="cnt_audit_outer_wrap">
                {topActionItemPlan.status ?
                  <DatagridComp className="datagrid_custom_scroll"
                    columns={columns}
                    rows={rows}
                    autoheightval={autoheightval}
                    datagridval={2}
                    columnFreezeWidth={[0]}
                    tableLoading={tableLoading}
                    handleDownlodingCSV={handleDownlodingCSV}
                    handleDownlodingPDF={handleDownlodingPDF}
                    customFilter={false}
                    DownloadShowFile={true}
                    DownloadShowPDF={1}
                    DownloadShowCSV={2}
                  />
                  : <Freeaudit planStatus={topActionItemPlan} />
                }
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="footer-container">
        <Box className="footer-box">
          <Grid container className="footer-grid">
            <Grid item xs={12} md={6}>
              <div className="footer-left">
                <p className="footer-text">
                  All Rights Reserved Copyright © 2026 |
                  <a href="https://www.elitesiteoptimizer.ai/" target="_blank"> <span className="footer-brand"> Elite site Optimizer</span></a>
                </p>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div className="footer-right">
                <p>{/* Add content if needed */}</p>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <div className="cnt_audit_outer_wrap">
        <div >
          {toggle && <Rightsidebar close={() => setToggle(false)} setToggle={setToggle} initialfaqDateval={initialfaqDateval} />}

        </div>
        <CommonAlert setOpenCommonAlerts={setOpenCommonAlerts} />
        <UserActivityTracker pagename="Top Action Items" />
      </div>
    </div>
  );
}
